import { Component, OnInit, Input, Output, EventEmitter, OnChanges} from '@angular/core';


@Component({
    selector: 'app-bus-layout',
    templateUrl: './bus-layout.component.html',
    standalone: false
})
export class BusLayoutComponent implements OnInit, OnChanges {
  @Input() deckLayouts: any[] = [];
  @Input() orientation = '';
  @Input() interactive;
  @Output() emptyDeckSeat: EventEmitter<any> = new EventEmitter();
  @Output() bookedDeckSeat: EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnInit() {

  }

  ngOnChanges() {
    this.ProcessSeatLayoutData();
  }

  ProcessSeatLayoutData() {
    if (this.deckLayouts !== undefined && this.deckLayouts !== null) {
      for (let layout = 0; layout < this.deckLayouts.length; layout++) {
        const deck = this.deckLayouts[layout];
        if (this.orientation !== 'horizontal') {
          deck.driverX = this.widthPercentageToPx(deck.width, deck.height, deck.driverX);
          deck.driverY = this.widthPercentageToPx(deck.width, deck.height, deck.driverY);
          deck.driverWidth = this.widthPercentageToPx(deck.width, deck.height, deck.driverWidth);
          deck.driverHeight = this.widthPercentageToPx(deck.width, deck.height, deck.driverHeight);
        } else {
          deck.driverX = this.widthPercentageToPx(deck.width, deck.height, deck.driverY);
          deck.driverY = this.widthPercentageToPx(deck.width, deck.height, deck.driverX) - deck.driverHeight;
          deck.driverWidth = this.widthPercentageToPx(deck.width, deck.height, deck.driverHeight);
          deck.driverHeight = this.widthPercentageToPx(deck.width, deck.height, deck.driverWidth);
        }
      }
    }
  }

  widthPercentageToPx(width, height, percentage) {
    if (this.orientation === 'horizontal') {
      width = height;
    }
    return width * percentage / 100;
  }

  onEmptySeatInDeck(seatIndex) {
    this.emptyDeckSeat.emit(seatIndex);
  }

  onBookedSeat(event) {
    this.bookedDeckSeat.emit(event);
  }

}
